import useIsMobile from "../hooks/useIsMobile";
import "./FirstPage.css";

import arrowRight from "../imgs/arrowRight.svg";
import bg from "../images/firstPageBg.svg";
import bgMobile from "../imgs/bg-phone-top.svg";
import cover from "../imgs/cover.png";
import VideoPlayer from "../Components/VideoPlayer";
import SplitText from "../Components/SplitText/SplitText";
import TextType from "../Components/TextType/TextType";

const data = "https://brevis-media-res.s3.us-west-1.amazonaws.com/website/mp4/video.mp4"

export const openTalk = () => {
  window.open("https://form.typeform.com/to/lduiliob", "_blank");
};
export const openDocument = () => {
  window.open("https://pico-docs.brevis.network/", "_blank");
};
export const openJoin = () => {
  window.open("https://discord.com/invite/brevis", "_blank");
};

function FirstPage() {
  const { isMobile } = useIsMobile();

  return (
    <div className="firstPage" id="firstPage">
      {/* <div className="bg_col" style={{ left: 150 }} />
      <div className="bg_col" style={{ left: 459 }} />
      <div className="bg_col" style={{ left: "50%" }} />
      <div className="bg_col" style={{ right: 435 }} />
      <div className="bg_col" style={{ right: 150 }} />

      <div className="bg_row" style={{ top: 135 }} />
      <div className="bg_row" style={{ top: 277 }} />
      <div className="bg_row" style={{ top: "50%" }} />
      <div className="bg_row" style={{ bottom: 277 }} />
      <div className="bg_row" style={{ bottom: 135 }} /> */}
      <img src={isMobile ? bgMobile : bg} alt="" className="firstPageBg" />
      {!isMobile && (
        <div className="videoArea">
          <div className="videoIn">
            <div className="videoCover"></div>
            <VideoPlayer
              src={data}
              width="300px"
              height="300px"
              poster={cover}
            />
          </div>
        </div>
      )}
      {/* <img
        alt=""
        className="place1"
        src={place1}
        style={{ position: "absolute", top: 270, left: 570 }}
      /> */}

      {!isMobile && (
        <div
          className="link talk_link"
          onClick={() => {
            openTalk();
          }}
        >
          [ Talk to our Team ]
          <img
            alt=""
            className="arrow_right"
            src={arrowRight}
            onClick={() => {}}
          />
        </div>
      )}
      {!isMobile && (
        <div
          className="link explore_link"
          onClick={() => {
            openDocument();
          }}
        >
          [ Explore Documentation ]
          <img
            alt=""
            className="arrow_right"
            src={arrowRight}
            onClick={() => {}}
          />
        </div>
      )}
      {!isMobile && (
        <div
          className="link join_link"
          onClick={() => {
            openJoin();
          }}
        >
          [ Join our Community ]
          <img
            alt=""
            className="arrow_right"
            src={arrowRight}
            onClick={() => {}}
          />
        </div>
      )}
      <div className="firstpage_bottom">
        {isMobile ? (
          <div className="firstpage_bottom_text1">
            Infinite Compute Layer for
          </div>
        ) : (
          <div>
            <SplitText
              text="Infinite Compute Layer for"
              className="firstpage_bottom_text1"
              delay={100}
              duration={0.6}
              ease="power3.out"
              splitType="chars"
              from={{ opacity: 0, y: 40 }}
              to={{ opacity: 1, y: 0 }}
              threshold={0.1}
              rootMargin="-100px"
              textAlign="center"
              onLetterAnimationComplete={() => {}}
            />
          </div>
        )}
        <div className="firstpage_bottom_text2">
          <TextType
            // text={["{Everything}"]}
            text={["{Web3}", "{AI}", "{Everything}"]}
            typingSpeed={75}
            pauseDuration={1500}
            showCursor={true}
            cursorCharacter="|"
            startOnVisible
            loop
            cursorClassName="testCursor"
          />
        </div>
        <div className="firstpage_bottom_text3">
          Prove with zero knowledge. Verify instantly. Build impossible
          applications.
        </div>
      </div>
    </div>
  );
}

export default FirstPage;
